import { getServicingAgents } from "./getServicingAgents";
import { getWritingAgents } from "./getWritingAgents";

export const getAgentsFromPolicy = (policy) => {
  const serviceAgents = getServicingAgents(policy);
  const writingAgents = getWritingAgents(policy);

  return serviceAgents.length ? serviceAgents : writingAgents;
};
